import { render, staticRenderFns } from "./CoursewareGalleryBlock.vue?vue&type=template&id=12b8b9bf&scoped=true&"
import script from "./CoursewareGalleryBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareGalleryBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareGalleryBlock.vue?vue&type=style&index=0&id=12b8b9bf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b8b9bf",
  null
  
)

export default component.exports